export default __webpack_public_path__ + "static/media/create-discover-success.398217cb.png";